import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "config";

export const verifyKyc = (userId: number, pan: string, dob: string) =>
    axiosInstance.request({
        baseURL: gatewayUrl,
        url: `egold/pan-verification`,
        method: "post",
        data: {
            pan,
            dob: new Date(dob).getTime(),
            user_id: userId,
        },
    });

export const verifyBankAccountAndPan = (bankAccountNo: string, ifsc: string) =>
    axiosInstance.request({
        baseURL: gatewayUrl,
        url: `egold/bank-account-verify`,
        method: "post",
        data: {
            bankAccountNo,
            ifsc
        },
    });